function StudentSettingsController($scope, $state) {}
StudentSettingsController.$inject = ["$scope", "$state"];
export default StudentSettingsController;
